import React from "react";

/**
 * Full-width, button-styled label (not interactive). Used below copyright on legal pages.
 */
export default function LegalPageBanner({ className = "" }) {
  return (
    <div
      className={`w-full min-w-0 cursor-default select-none rounded-2xl border border-white/25 bg-white/5 px-4 py-4 text-center text-sm font-semibold uppercase tracking-[0.12em] text-white shadow-sm sm:px-8 sm:py-5 sm:text-base ${className}`}
      role="status"
      aria-label="Legal information documents"
    >
      Legal Informations
    </div>
  );
}
